export const getPublicUrl = (tenantName: string, path: string) => {
  const publicUrl = import.meta.env.VITE_PUBLIC_URL || "";
  return [publicUrl.replace("TENANT", tenantName), path].join("");
};
